export const sellerData = {
    id: 1,
    name: "Seller 1",
    avatarImage: "/images/user.jpg",
    rating: 4.9,
    totalSales: 42,
    joinDate: "2018",
    verification: "Verified Seller",
    location: "Waterloo, ON",
    shippingTime: "1-2 business days",
    reviews: [
        {
            id: 1,
            reviewer: "User1",    
            rating: 5,
            comment: "Great seller! Fast shipping and item as described.",
            date: "2024-05-01"
        },
        {
            id: 2,
            reviewer: "User2",   
            rating: 4,
            comment: "Good communication, but item arrived a bit late.",
            date: "2024-04-15"
        },
    {
            id: 3,
            reviewer: "User3",   
            rating: 4,
            comment: "Good communication, but item arrived a bit late.",
            date: "2024-04-15"
        },
        {
            id: 4,
            reviewer: "User4",   
            rating: 4,
            comment: "Good communication, but item arrived a bit late.",
            date: "2024-04-15"
        },
                {
            id: 5,
            reviewer: "User5",   
            rating: 5,
            comment: "Excellent seller! Highly recommended.",
            date: "2024-04-15"
        },
    ] 
  };